import { z } from 'zod';
export const PlatformSchema = z.enum(['telegram', 'max']);
export const LanguageSchema = z.enum(['ru', 'en']);
export const GenderSchema = z.enum(['female', 'male', 'other']);
export const AuthInitRequestSchema = z.object({
    platform: PlatformSchema,
    initData: z.string().min(1),
    /** Optional language hint from the platform (e.g. user.language_code from TG). */
    languageHint: z.string().optional(),
});
export const PublicUserSchema = z.object({
    id: z.string().uuid(),
    platform: PlatformSchema,
    name: z.string().nullable(),
    gender: GenderSchema.nullable(),
    language: LanguageSchema,
    birthDate: z.string().nullable(),
    birthTime: z.string().nullable(),
    birthPlaceName: z.string().nullable(),
    birthPlaceLat: z.number().nullable(),
    birthPlaceLon: z.number().nullable(),
    /** @deprecated derive from birthTime !== null. Kept for compat. */
    hasBirthTime: z.boolean(),
    /** @deprecated derive from birthPlaceLat !== null. Kept for compat. */
    hasBirthPlace: z.boolean(),
    timezone: z.string(),
    notificationsEnabled: z.boolean(),
    notificationTime: z.string(),
    referralCode: z.string(),
});
export const AuthInitResponseSchema = z.object({
    user: PublicUserSchema,
    isNew: z.boolean(),
    jwt: z.string().min(1),
    /**
     * Pre-built referral deeplink for this user's platform — the URL the
     * client should hand to native share dialogs. Server-side build avoids
     * each client cobbling together URLs and getting bot_username wrong.
     */
    referralLink: z.string(),
});
//# sourceMappingURL=auth.js.map